import React, { ReactNode, useMemo } from "react";

import { faRedoAlt } from "@fortawesome/pro-solid-svg-icons/faRedoAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import DealStageType from "@mapmycustomers/shared/enum/DealStageType";
import { Deal } from "@mapmycustomers/shared/types/entity";

import styles from "./useActions.module.scss";

const useActions = (
  deal: Deal,
  onMarkLost?: () => void,
  onMarkWon?: () => void,
  onReopen?: () => void
): ReactNode[] => {
  const intl = useIntl();
  return useMemo(
    () =>
      deal.stage.type === DealStageType.WON || deal.stage.type === DealStageType.LOST
        ? [
            <div className={styles.reOpenButton} key="reopen" onClick={onReopen}>
              {intl.formatMessage({
                id: "dealRecord.quickEdit.reopen",
                defaultMessage: "Reopen Deal",
                description: "Title of reOpen deal button",
              })}
              <FontAwesomeIcon icon={faRedoAlt} />
            </div>,
          ]
        : [
            <div className={styles.wonButton} key="mark-won" onClick={onMarkWon}>
              {intl.formatMessage({
                id: "dealRecord.quickEdit.markWon",
                defaultMessage: "Mark Won",
                description: "Title of Mark Won deal button",
              })}
            </div>,
            <div className={styles.lostButton} key="mark-lost" onClick={onMarkLost}>
              {intl.formatMessage({
                id: "dealRecord.quickEdit.markLost",
                defaultMessage: "Mark Lost",
                description: "Title of Mark Lost deal button",
              })}
            </div>,
          ],
    [deal, intl, onMarkLost, onMarkWon, onReopen]
  );
};

export default useActions;
